const printerErrorMap = {
    // MB 5th & 6th gen machine & toolhead errors
    0: {
        "name": "none",
        "pretty_name": "None"
    },
    11: {
        "name": "watchdog_triggered",
        "pretty_name": "Watchdog Triggered"
    },
    12: {
        "name": "invalid_response",
        "pretty_name": "Invalid Response"
    },
    13: {
        "name": "not_connected",
        "pretty_name": "Not Connected"
    },
    14: {
        "name": "command_index_mismatch",
        "pretty_name": "Command Index Mismatch"
    },
    15: {
        "title": "Chamber Heater Disconnect",
        "name": "chamber_not_connected",
        "pretty_name": "Chamber Not Connected",
        "message": "The build chamber heater controller is disconnected (Error 15). Please visit our Support page at Makerbot.com/support."
    },
    16: {
        "title": "Carriage Disconnected",
        "name": "carriage_not_connected",
        "pretty_name": "Carriage Not Connected",
        "message": "The extruder carriage is disconnected from the machine (Error 16). Please visit our Support page at Makerbot.com/support."
    },
    45: {
        "title": "Top Lid Open",
        "name": "lid_interlock_triggered",
        "pretty_name": "Lid Interlock Triggered",
        "message": "The top lid is open (Warning 45). Please close the lid to continue."
    },
    46: {
        "title": "Extruder Error",
        "name": "bad_tool_connected",
        "pretty_name": "Bad Tool Connected",
        "message": "Oops, we have a problem with your Smart Extruder (Error 46). Please detach and reattach your Smart Extruder."
    },
    47: {
        "name": "ac_power_disconnected",
        "pretty_name": "AC Power Disconnected"
    },
    48: {
        "title": "Chamber Open",
        "name": "door_interlock_triggered",
        "pretty_name": "Door Interlock Triggered",
        "message": "The heated build chamber is open (Warning 48). Please close the door to continue."
    },
    49: {
        "name": "tool_short",
        "pretty_name": "Tool Short"
    },
    50: {
        "name": "heater_short",
        "pretty_name": "Heater Short"
    },
    51: {
        "name": "tool_fan_short",
        "pretty_name": "Tool Fan Short"
    },
    52: {
        "name": "filament_fan_short",
        "pretty_name": "Filament Fan Short"
    },
    53: {
        "name": "motor_over_current",
        "pretty_name": "Motor Over Current"
    },
    54: {
        "title": "Extruder Error",
        "name": "no_tool_connected",
        "pretty_name": "No Tool Connected",
        "message": "Your Smart Extruder is not connected (Error 54). Please reconnect your Smart Extruder."
    },
    55: {
        "name": "heater_rise_watchdog_triggered",
        "pretty_name": "Heater Rise Watchdog Triggered"
    },
    56: {
        "title": "Extruder Cooling",
        "name": "heater_hold_watchdog_triggered",
        "pretty_name": "Heater Hold Watchdog Triggered",
        "message": "Your extruder cools down if the printer stays idle for a few minutes."
    },
    57: {
        "name": "heater_temperature_sag_triggered",
        "pretty_name": "Heater Temperature Sag Triggered"
    },
    58: {
        "name": "heater_temperature_overrun_triggered",
        "pretty_name": "Heater Temperature Overrun Triggered"
    },
    59: {
        "name": "toolhead_timed_out",
        "pretty_name": "Toolhead Timed Out"
    },
    60: {
        "name": "toolhead_communication_error",
        "pretty_name": "Toolhead Communication Error"
    },
    65: {
        "title": "Extruder Error",
        "name": "thermocouple_communication_failure",
        "pretty_name": "Thermocouple Communication Failure",
        "message": "Your Smart Extruder has been disconnected (Error 65). Please remove and reattach the Smart Extruder."
    },
    66: {
        "name": "thermocouple_out_of_range",
        "pretty_name": "Thermocouple Out Of Range"
    },
    67: {
        "name": "thermocouple_unplugged",
        "pretty_name": "Thermocouple Unplugged"
    },
    68: {
        "name": "thermocouple_too_hot",
        "pretty_name": "Thermocouple Too Hot"
    },
    69: {
        "name": "thermocouple_data_invalid",
        "pretty_name": "Thermocouple Data Invalid"
    },
    70: {
        "name": "tool_open",
        "pretty_name": "Tool Open"
    },
    71: {
        "name": "heater_open",
        "pretty_name": "Heater Open"
    },
    72: {
        "name": "tool_fan_open",
        "pretty_name": "Tool Fan Open"
    },
    73: {
        "name": "filament_fan_open",
        "pretty_name": "Filament Fan Open"
    },
    74: {
        "name": "heater_over_temp",
        "pretty_name": "Heater Over Temp"
    },
    75: {
        "name": "thermocouple_data_unchanging",
        "pretty_name": "Thermocouple Data Not Changing"
    },
    76: {
        "title": "Stall Condition Detected",
        "name": "unusual_stall_condition",
        "pretty_name": "Stall Condition Detected",
        "message": "An unusual print error has occurred. To protect your extruder, the print was cancelled. Try the print again and this error will most likely not reoccur."
    },
    78: {
        "name": "malformed_packet",
        "pretty_name": "Malformed Packet"
    },
    79: {
        "name": "invalid_tool_index",
        "pretty_name": "Invalid Tool Index"
    },
    80: {
        "title": "Out of Filament",
        "name": "no_filament",
        "pretty_name": "No Filament",
        "message": "This process requires filament to proceed. (Warning 80)"
    },
    81: {
        "title": "Filament Jam",
        "name": "filament_slip",
        "pretty_name": "Filament Slip",
        "message": "Your filament seems to be jammed (Error 81). Please unload your remaining filament, and then reload it to continue printing."
    },
    82: {
        "name": "hes_log_full",
        "pretty_name": "HES Log Full"
    },
    83: {
        "name": "drawer_no_filament",
        "pretty_name": "Extruder Out Of Material"
    },
    85: {
        "name": "unsupported_tool",
        "pretty_name": "Unsupported Tool"
    },
    86: {
        "name": "tool_read_error",
        "pretty_name": "Tool Read Error"
    },
    87: {
        "name": "tool_checksum_fail",
        "pretty_name": "Tool Checksum Fail"
    },
    88: {
        "name": "invalid_encoder_resolution",
        "pretty_name": "Invalid Encoder Resolution"
    },
    89: {
        "name": "command_too_long",
        "pretty_name": "Command Too Long"
    },
    90: {
        "name": "tool_buffer_full",
        "pretty_name": "Tool Buffer Full"
    },
    91: {
        "name": "toolhead_buffer_full",
        "pretty_name": "Toolhead Buffer Full"
    },
    95: {
        "name": "eeprom_checksum_failure",
        "pretty_name": "Eeprom Checksum Failure"
    },
    96: {
        "name": "chamber_thermistor_disconnected",
        "pretty_name": "Chamber Thermistor Disconnected"
    },
    97: {
        "name": "chamber_heater_disconnected",
        "pretty_name": "Chamber Heater Disconnected"
    },
    98: {
        "name": "chamber_heater_failure",
        "pretty_name": "Chamber Heater Failure"
    },
    99: {
        "name": "chamber_fan_failure",
        "pretty_name": "Chamber Fan Failure"
    },
    100: {
        "name": "chamber_temperature_overrun",
        "pretty_name": "Chamber Temperature Overrun"
    },
    101: {
        "name": "i2c_comm_error",
        "pretty_name": "I2C Communication Error"
    },
    129: {
        "name": "thermocouple_adc_busy",
        "pretty_name": "Thermocouple Adc Busy"
    },
    130: {
        "name": "mismatch_api_version",
        "pretty_name": "Mismatch Api Version"
    },
    131: {
        "name": "eeprom_no_slave_ack",
        "pretty_name": "Eeprom No Slave Ack"
    },
    132: {
        "name": "eeprom_start_failure",
        "pretty_name": "Eeprom Start Failure"
    },
    133: {
        "name": "eeprom_slave_missed_value",
        "pretty_name": "Eeprom Slave Missed Value"
    },
    134: {
        "name": "eeprom_id_verify_fail",
        "pretty_name": "Eeprom Id Verify Fail"
    },
    135: {
        "name": "eeprom_unknown_version",
        "pretty_name": "Eeprom Unknown Version"
    },
    136: {
        "name": "eeprom_fatal_internal_error",
        "pretty_name": "Eeprom Fatal Internal Error"
    },
    137: {
        "name": "eeprom_out_of_date",
        "pretty_name": "Eeprom Out Of Date"
    },
    138: {
        "name": "busy",
        "pretty_name": "Busy"
    },
    139: {
        "name": "empty_eeprom_cache",
        "pretty_name": "Empty EEPROM Cache"
    },
    140: {
        "name": "eeprom_write_failure",
        "pretty_name": "EEPROM Write Failure"
    },
    141: {
        "name": "eeprom_verify_failure",
        "pretty_name": "EEPROM Verify Failure"
    },
    142: {
        "name": "program_not_started",
        "pretty_name": "Program Not Started"
    },
    143: {
        "name": "program_completed",
        "pretty_name": "Program Completed"
    },
    144: {
        "name": "serious_internal_error",
        "pretty_name": "Serious Internal Error"
    },
    145: {
        "name": "nfc_scan_failure",
        "pretty_name": "NFC Scan Failure"
    },
    147: {
        "name": "nfc_read_failure",
        "pretty_name": "NFC Read Failure"
    },
    148: {
        "name": "nfc_write_failure",
        "pretty_name": "NFC Write Failure"
    },
    149: {
        "name": "nfc_uid_mismatch",
        "pretty_name": "NFC UID Mismatch"
    },
    256: {
        "name": "ok",
        "pretty_name": "Ok"
    },
    257: {
        "name": "user_config_not_found",
        "pretty_name": "User Config Not Found"
    },
    258: {
        "name": "user_config_parse_failure",
        "pretty_name": "User Config Parse Failure"
    },
    259: {
        "name": "user_config_missing_value",
        "pretty_name": "User Config Missing Value"
    },
    260: {
        "name": "no_toolheads_detected",
        "pretty_name": "No Toolheads Detected"
    },
    261: {
        "name": "invalid_acceleration_buffer_size",
        "pretty_name": "Invalid Acceleration Buffer Size"
    },
    262: {
        "name": "toolhead_mismatch_api_version",
        "pretty_name": "Toolhead Mismatch Api Version"
    },
    263: {
        "name": "toolhead_no_response",
        "pretty_name": "Toolhead No Response"
    },
    264: {
        "name": "json_toolpath_nothing_parsed",
        "pretty_name": "Json Toolpath Nothing Parsed"
    },
    265: {
        "name": "invalid_axis",
        "pretty_name": "Invalid Axis"
    },
    266: {
        "name": "not_ready",
        "pretty_name": "Not Ready"
    },
    267: {
        "name": "heat_zero_temperature",
        "pretty_name": "Heat Zero Temperature"
    },
    268: {
        "name": "invalid_heater_index",
        "pretty_name": "Invalid Heater Index"
    },
    269: {
        "name": "heater_add_failure",
        "pretty_name": "Heater Add Failure"
    },
    270: {
        "name": "toolhead_malformed_packet",
        "pretty_name": "Toolhead Malformed Packet"
    },
    271: {
        "name": "zero_length_move",
        "pretty_name": "Zero Length Move"
    },
    272: {
        "name": "toolhead_not_initialized",
        "pretty_name": "Toolhead Not Initialized"
    },
    273: {
        "name": "remote_full",
        "pretty_name": "Remote Full"
    },
    274: {
        "name": "machine_driver_closed",
        "pretty_name": "Machine Driver Closed"
    },
    275: {
        "name": "z_pause_value_not_found",
        "pretty_name": "Z Pause Value Not Found"
    },
    276: {
        "name": "local_empty",
        "pretty_name": "Local Buffer Empty"
    },
    277: {
        "name": "extrusion_distance_missing",
        "pretty_name": "Extrusion Distance Missing"
    },
    278: {
        "name": "invalid_active_tool_setting",
        "pretty_name": "Invalid Active Tool Setting"
    },
    279: {
        "name": "invalid_tool_requested",
        "pretty_name": "Invalid Tool Requested"
    },
    280: {
        "name": "parse_more",
        "pretty_name": "Parse More"
    },
    281: {
        "name": "buffer_full",
        "pretty_name": "Buffer Full"
    },
    282: {
        "name": "keep_calling",
        "pretty_name": "Keep Calling"
    },
    283: {
        "name": "invalid_fan_duty",
        "pretty_name": "Invalid Fan Duty"
    },
    284: {
        "name": "top_bunk_fan_failure",
        "pretty_name": "Top Bunk Fan Failure"
    },
    287: {
        "name": "stop_iteration",
        "pretty_name": "Stop Iteration"
    },
    288: {
        "name": "interface_led_comms_error",
        "pretty_name": "Interface Led Comms Error"
    },
    289: {
        "name": "invalid_program_path",
        "pretty_name": "Invalid Program Path"
    },
    290: {
        "name": "tool_program_failed",
        "pretty_name": "Tool Program Failed"
    },
    295: {
        "name": "power_monitor_i2c_failure",
        "pretty_name": "Power Monitor I2C Failure"
    },
    296: {
        "name": "diagnostics_unknown_state_error",
        "pretty_name": "Diagnostics Unknown State Error"
    },
    297: {
        "name": "diagnostics_test_failed",
        "pretty_name": "Diagnostics Test Failed"
    },
    298: {
        "name": "diagnostis_uknown_test_error",
        "pretty_name": "Diagnostis Uknown Test Error"
    },
    299: {
        "name": "bad_tool_count_config",
        "pretty_name": "Bad Tool Count Config"
    },
    300: {
        "name": "not_implemented",
        "pretty_name": "Not Implemented"
    },
    301: {
        "name": "resume_complete",
        "pretty_name": "Resume Complete"
    },
    500: {
        "name": "kaiten_error",
        "pretty_name": "System Error"
    },
    501: {
        "title": "Print Paused",
        "name": "z_pause",
        "pretty_name": "Z Pause",
        "message": "Paused your print. (TODO-This probably shouldn't be an error? #checkoutmysushitho 501)"
    },
    504: {
        "name": "heater_not_heating",
        "pretty_name": "Heater Not Heating"
    },
    900: {
        "title": "Wireless Network Error",
        "name": "wifi_general_error",
        "pretty_name": "Wireless Network General Error",
        "message": "There was a problem connecting to the network  (Error 900)."
    },
    901: {
        "title": "Wireless Network Error",
        "name": "wifi_ssid_required",
        "pretty_name": "Wireless Network SSID Required",
        "message": "The SSID of the wireless network must be specified  (Error 901)."
    },
    902: {
        "title": "Wireless Network Error",
        "name": "wifi_password_invalid",
        "pretty_name": "Wireless Network Password Invalid",
        "message": "The password specified for the wireless network is invalid (Error 902)"
    },
    903: {
        "title": "Wireless Network Error",
        "name": "wifi_password_required",
        "pretty_name": "Wireless Netowrk Requires Password",
        "message": "The specified wireless network requires a password (Error 903)"
    },
    904: {
        "title": "Wireless Network Not Found",
        "name": "wifi_no_such_ssid",
        "pretty_name": "Wireless Network Not Found",
        "message": "The specified wireless network could not be found (Error 904)"
    },
    905: {
        "title": "Wireless Configuration Error",
        "name": "wifi_ethernet_connected",
        "pretty_name": "Ethernet Connected During Wifi Setup",
        "message": "Wireless configuration cannot proceed while a network cable is plugged in."
    },
    1001: {
        "title": "Heating Error",
        "name": "toolhead_not_heating",
        "pretty_name": "Toolhead Not Heating",
        "message": "DO NOT touch the extruder as it may be very hot (Error 1001). Please visit our Support page at Makerbot.com/support."
    },
    1003: {
        "name": "default_config_not_found",
        "pretty_name": "Default Config Not Found"
    },
    1004: {
        "name": "default_config_parse_failure",
        "pretty_name": "Default Config Parse Failure"
    },
    1005: {
        "name": "default_config_missing_value",
        "pretty_name": "Default Config Missing Value"
    },
    1006: {
        "name": "pru_initialization_failed",
        "pretty_name": "Pru Initialization Failed"
    },
    1008: {
        "name": "toolhead_command_tx_failure",
        "pretty_name": "Toolhead Command Tx Failure"
    },
    1009: {
        "title": "Carriage Program Failed",
        "name": "carriage_program_failure",
        "pretty_name": "Carriage Program Failure",
        "message": "The extruder carriage cannot be programmed (Error 1009). Please visit our Support page at Makerbot.com/support."
    },
    1010: {
        "title": "Chamber Program Failed",
        "name": "chamber_program_failure",
        "pretty_name": "Chamber Program Failure",
        "message": "The build chamber heater controller cannot be programmed (Error 1010). Please visit our Support page at Makerbot.com/support."
    },
    1011: {
        "name": "json_toolpath_parse_error",
        "pretty_name": "Json Toolpath Parse Error"
    },
    1012: {
        "name": "file_not_found",
        "pretty_name": "File Not Found"
    },
    1013: {
        "name": "homing_timed_out",
        "pretty_name": "Homing Timed Out"
    },
    1014: {
        "title": "Extruder Error",
        "name": "print_tool_connect_failed",
        "pretty_name": "Print Tool Connect Failed",
        "message": "Smart Extruder Connect Failed (Error 1014).  Please disconnect your Smart Extruder and try again."
    },
    1015: {
        "name": "invalid_eeprom_filepath",
        "pretty_name": "Invalid Eeprom Filepath"
    },
    1016: {
        "name": "homing_not_completed",
        "pretty_name": "Homing Not Completed"
    },
    1017: {
        "name": "toolhead_spi_config_error",
        "pretty_name": "Toolhead Spi Config Error"
    },
    1018: {
        "name": "suspend_index_not_found",
        "pretty_name": "Suspend Index Not Found"
    },
    1019: {
        "name": "suspend_no_valid_last_move",
        "pretty_name": "Suspend No Valid Last Move"
    },
    1020: {
        "name": "no_valid_hes_slope",
        "pretty_name": "No Valid Hes Slope"
    },
    1021: {
        "name": "bad_print_file",
        "pretty_name": "Print File Corrupt"
    },
    1022: {
        "name": "hes_rebase_failed",
        "pretty_name": "Hes Rebase Failed"
    },
    1023: {
        "name": "no_hes_log",
        "pretty_name": "No Hes Log"
    },
    1024: {
        "title": "Homing Error",
        "name": "no_hes_change",
        "pretty_name": "No Hes Change",
        "message": "Homing failed (Error 1024). Your Smart Extruder is not communicating. Please try again."
    },
    1025: {
        "name": "unknown_homing_method",
        "pretty_name": "Unknown Homing Method"
    },
    1026: {
        "name": "power_monitor_adc_failure",
        "pretty_name": "Power Monitor ADC Failure"
    },
    1027: {
        "title": "Leveling Error",
        "name": "both_sides_too_high",
        "pretty_name": "Both Sides Too High",
        "message": "Leveling failed (Error 1027). Your extruder nozzle may be stuck. Please try again."
    },
    1028: {
        "title": "Clear Filament",
        "name": "leveling_with_filament",
        "pretty_name": "Leveling With Filament",
        "message": "Please remove filament from the Smart Extruder before proceeding (Warning 1028)."
    },
    1029: {
        "title": "No Build Plate",
        "name": "no_build_plate",
        "pretty_name": "No Build Plate",
        "message": "Please ensure your build plate is properly attached (Warning 1029)."
    },
    1030: {
        "name": "file_transfer_timeout",
        "pretty_name": "File Transfer Timeout"
    },
    1031: {
        "name": "corrupted_firmware_file",
        "pretty_name": "Corrupted Firmware File"
    },
    1032: {
        "name": "bad_hes_waveforms",
        "pretty_name": "Bad Hes Waveforms"
    },
    1033: {
        "name": "hes_log_overflow",
        "pretty_name": "Hes Log Overflow"
    },
    1034: {
        "name": "knob_not_tightened",
        "pretty_name": "Knob Not Tightened"
    },
    1035: {
        "name": "invalid_endstop_type",
        "pretty_name": "Invalid Endstop Type"
    },
    1036: {
        "name": "no_mac_address_set",
        "pretty_name": "No Mac Address Set"
    },
    1037: {
        "name": "toolhead_feeder_sleep_interrupted",
        "pretty_name": "Toolhead Feeder Sleep Interrupted"
    },
    1038: {
        "name": "could_not_send_toolhead_command",
        "pretty_name": "Could Not Send Toolhead Command"
    },
    1039: {
        "title": "File Error",
        "name": "move_command_outside_axis_bounds",
        "pretty_name": "Move Command Outside Axis Bounds",
        "message": "Error 1039: Please make sure that your .makerbot file is prepared for the correct printer type."
    },
    1040: {
        "title": "No Filament",
        "name": "no_filament_loaded",
        "pretty_name": "No Filament",
        "message": "Please load filament before starting your print. (Warning 1040)"
    },
    1041: {
        "title": "Out of Material",
        "name": "out_of_filament",
        "pretty_name": "Out of Material",
        "message": "Please wait while your extruder unloads any leftover material. (Warning 1041)"
    },
    1042: {
        "title": "Network Error",
        "name": "printing_network_error",
        "pretty_name": "Network Error",
        "message": "There was a problem communicating with MakerBot Cloud Services. Please try your print again later. (Warning 1042)"
    },
    1043: {
        "title": "Slicing Error",
        "name": "cloud_slicing_error",
        "pretty_name": "Slicing Error",
        "message": "Failed to slice your layout for printing. Please try again later. (Warning 1043)"
    },
    1044: {
        "name": "unsupported_eeprom_version",
        "pretty_name": "Upload candidate EEPROM map is unsupported by the current tool"
    },
    1045: {
        "name": "eeprom_update_failed",
        "pretty_name": "Smart Extruder Update Failed"
    },
    1046: {
        "title": "Run Calibration",
        "name": "tool_not_calibrated",
        "pretty_name": "Smart Extruder Not Calibrated",
        "message": "Please run Homing Calibration before printing with this Smart Extruder"
    },
    1048: {
        "title": "Print File Error",
        "name": "print_extruder_mismatch",
        "pretty_name": "Slice Incompatible: Extruder",
        "message": "The selected print was sliced for a %1, but a %2 is attached. Please reslice for a %2. (Error 1048)"
    },
    1049: {
        "title": "Print File Error",
        "name": "print_machine_mismatch",
        "pretty_name": "Slice Incompatible: Machine",
        "message": "This print file was sliced for a different machine type. Please reslice for the correct printer. (Error 1049)"
    },
    1050: {
        "title": "Print File Error",
        "name": "print_version_mismatch",
        "pretty_name": "Slice Incompatible: Version",
        "message": "This print file is not compatible with this firmware version. Please upgrade firmware. (Error 1050)"
    },
    1051: {
        "name": "insufficient_usb_space",
        "pretty_name": "Insufficient Disk Space",
        "message": "There is not enough free space on the attached USB drive."
    },
    1052: {
        "title": "Print File Error",
        "name": "print_raft_disabled",
        "pretty_name": "Slice Incompatible: Raft",
        "message": "The selected print was sliced without a raft, but a raft is recommended for this type of printer. Please reslice with a raft. (Error 1052)"
    },
    1053: {
        "name": "firmware_update_check_error",
        "pretty_name": "Firmware Update Check Error",
        "message": "Could not check for firmware updates. Please contact Support."
    },
    1054: {
        "name": "firmware_download_error",
        "pretty_name": "Firmware Download Error",
        "message": "Could not download firmware. Please contact Support."
    },
    1055: {
        "name": "internet_connection_error",
        "pretty_name": "Internet Connection Error",
        "message": "Could not connect to the Internet."
    },
    1056: {
        "title": "Invalid URL",
        "name": "printing_url_error",
        "pretty_name": "Invalid URL",
        "message": "There was a problem downloading the .makerbot file from the URL provided."
    },
    1057: {
        "title": "Temporary Filament Jam",
        "name": "recoverable_filament_jam",
        "message": "Clearing extruder to resolve temporary filament jam."
    },
    1058: {
        "name": "hes_no_contact",
        "pretty_name": "Hes made no contact"
    },
    1059: {
        "name": "hes_reversed",
        "pretty_name": "Hes Magnet Reversed"
    },
    1060: {
        "name": "log_hes_timed_out",
        "pretty_name": "Log HES Data Timed Out"
    },
    1061: {
        "name": "no_nfc_tags_found",
        "pretty_name": "No NFC Tags Found"
    },
    1070: {
        "name": "assist_motor_over_temp",
        "pretty_name": "Assist Motor is Over Temperature and has timed out."
    },
    1100: {
        "name": "operation_timed_out",
        "pretty_name": "Internal Timeout",
        "message": "Internal operation timed out. Please contact Support."
    },
    1496: {
        "name": "json_config_key_error",
        "pretty_name": "Configuration Key Error"
    },
    1497: {
        "name": "json_config_value_error",
        "pretty_name": "Configuration Value Error"
    },
    1498: {
        "name": "invalid_file_type",
        "pretty_name": "Invalid File Type"
    },
    1499: {
        "name": "file_already_open",
        "pretty_name": "File Already Open"
    },
    1500: {
        "name": "critical_kaiten_error",
        "pretty_name": "Critical System Error"
    },
    1501: {
        "name": "machine_driver_failure",
        "pretty_name": "Machine Driver Failure"
    },
    whitesmith: {
        74: {
            title: 'Extruder',
            message: 'Extruder temperature out of range.',
        },
        1039: {
            title: 'Model',
            message: 'Model out of bounds.',
        },
        1041: {
            title: 'Material',
            message: 'This process requires filament to proceed.',
        },
        1049: {
            title: 'Model',
            message: 'This print file was sliced for a different machine type. Please reslice for the correct printer.',
        },
        1056: {
            title: 'File',
            message: 'Error downloading .makerbot file from cloud.',
        },
        2003: {
            title: 'Model',
            message: 'This print file was sliced for a different machine type. Please reslice for the correct printer.',
        },
        default: {
            title: 'Sketch',
            message: 'This printer is experiencing an error.',
        },
    },    
}

module.exports = printerErrorMap;
